import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useDispatch } from 'react-redux';
import { DropdownButton } from '@famly/mf_input_dropdown-button';
import { logOut } from 'signin-app/login/actions';
import { useModal } from 'web-app/react/modal-context/modal-context';
import translate from 'signin-app/helpers/translate';
import { LogoutWarningModal } from './logout-warning-modal';
export const SettingsDropdown = (props) => {
    const dispatch = useDispatch();
    const { show, hide } = useModal({
        component: LogoutWarningModal,
        modalProps: {
            fullScreenOnMobile: false,
        },
    });
    const handleLogout = React.useCallback(() => dispatch(logOut.action()), [dispatch]);
    const handleClick = React.useCallback(() => {
        var _a;
        if (props.showWarning) {
            show({
                onModalClose: hide,
                onConfirm: () => {
                    hide();
                    handleLogout();
                },
                siteName: (_a = props.siteName) !== null && _a !== void 0 ? _a : '',
            });
        }
        else {
            handleLogout();
        }
    }, [handleLogout, hide, show, props]);
    const options = React.useMemo(() => {
        const logout = {
            label: translate('adminLogout'),
            onClick: handleClick,
            ['data-e2e-id']: 'logout-button',
        };
        return props.settings ? [...props.settings, logout] : [logout];
    }, [props.settings, handleClick]);
    return (_jsx(DropdownButton, { variant: props.variant === 'dark' ? 'primary' : 'tertiary', icon: "more_horiz", "aria-label": translate('settings'), "data-e2e-id": "settings-button", options: options }));
};
